/**
 * @generated SignedSource<<17a76491a2ca70b26f9703fe0922552d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_projectRef$data = {
  readonly key: string;
  readonly virtualAgentConfiguration: {
    readonly __typename: "VirtualAgentConfiguration";
    readonly __typename: "VirtualAgentConfiguration";
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly " $fragmentType": "virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_projectRef";
};
export type virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_projectRef$key = {
  readonly " $data"?: virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_projectRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_projectRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_projectRef",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "LinkedField",
      "name": "virtualAgentConfiguration",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        }
      ]
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "5e5d593857ba59b3d405f27e9d27a5e5";

export default node;
